import swal from 'sweetalert2';
import { CanvasTextWrapper } from 'canvas-text-wrapper';
import screenShooter from 'front_screenshot';
import bowser from 'bowser';
import config from '../../services/clientconfig';
import * as _ from 'lodash';


import layouts from '../../config/templates/templates_fromserver.json';

//  Flyleafes
import portraitFlyleafBack from '../../config/templates/flyleafes/back/portrait.json';
import portraitFlyleafFront from '../../config/templates/flyleafes/front/portrait.json';
import landscapeFlyleafBack from '../../config/templates/flyleafes/back/landscape.json';
import landscapeFlyleafFront from '../../config/templates/flyleafes/front/landscape.json';
import squareFlyleafBack from '../../config/templates/flyleafes/back/square.json';
import squareFlyleafFront from '../../config/templates/flyleafes/front/square.json';

import { loadImages } from '../actions/entities/images';

import {
  autoFill,
  setIsActive,
} from '../actions/entities/pages';

import { setAutoFill } from '../actions/ui/setAutoFill';
import { isPreviewFinished } from '../actions/ui/previewFinished';
import {
  getAutoFill,
  getContext,
  getBookId,
  getFormat,
  getDomain,
} from './getParams';

// Covers
import loadConsumerCoverTemplates from '../../config/templates/covers/consumer';
import loadProCoverTemplates from '../../config/templates/covers/pro';

import { autofillDisableDropCoverType } from './../../helpers/coverHelper';
import { template } from 'lodash';

const cookies = require('cookie-getter');

const bookFormat = getFormat();
const COVER_HEIGHT = 616;
const COVER_WIDTH = 1204;
const COSUMER_BOOK_SPINE_SIZE = 10;

export const INCH_IN_PX = 300;
export const CM_TO_INCH = 0.3937;
const MINIMUM_SHEETS = 5;
// 1mm in pixel
const MM_IN_PX = 2.8;

export function getBookSizes() {
  return {
    pageWidth: layouts.items[0].dimensions.pageWidth,
    pageHeight: layouts.items[0].dimensions.pageHeight,
  };
}

export function MmToPx(size) {
  return Math.round(((size / 10) * CM_TO_INCH) * INCH_IN_PX);
}

export const getCoverPrintSizes = (width, height) => ({
  width: MmToPx(width),
  height: MmToPx(height),
});

export const getConsumerSpineSize = () => MmToPx(COSUMER_BOOK_SPINE_SIZE);
export const getMmInPx = () => MM_IN_PX;
export const getOriginalHeight = bookSizes => parseInt(bookSizes.height, 10);
export const getOriginalWidth = bookSizes => parseInt(bookSizes.width, 10);
export const getCoverHeight = () => COVER_HEIGHT;
export const getCoverWidth = () => COVER_WIDTH;
export const getMinimumSheets = () => MINIMUM_SHEETS;

export const getSpineSize = (target, layoutWidth) => Math.round((MmToPx(layouts.items[0].dimensions.spine.initialWidth)) / (layoutWidth / target));
export const getSheets = () => ({
  maxSheets: layouts.items[0].maxSheets,
  minSheets: layouts.items[0].minSheets,
});

export function getMaximumImagePerPage(bookLayouts) {
  const lengths = [];
  Object.values(bookLayouts).map(item => lengths.push(item.placeholders.length));
  return Math.max(...lengths);
}

export const getFlyleafBack = (pageFormat) => {
  let getFlyleafTemplate = squareFlyleafBack;
  if (pageFormat === 'portrait') {
    getFlyleafTemplate = portraitFlyleafBack;
  } else if (pageFormat === 'landscape') {
    getFlyleafTemplate = landscapeFlyleafBack;
  }

  const flyleafes = getFlyleafTemplate.map((layout) => {
    const backFlyLeaf = Object.assign({}, layout);
    backFlyLeaf.isBackFlyleaf = true;
    return backFlyLeaf;
  });
  return flyleafes;
};

export const getFlyleafFront = (pageFormat) => {
  let getFlyleafTemplate = squareFlyleafFront;
  if (pageFormat === 'portrait') {
    getFlyleafTemplate = portraitFlyleafFront;
  } else if (pageFormat === 'landscape') {
    getFlyleafTemplate = landscapeFlyleafFront;
  }

  const getflyleafFront = getFlyleafTemplate.map((layout) => {
    const frontFlyLeaf = Object.assign({}, layout);
    frontFlyLeaf.isFrontFlyleaf = true;
    return frontFlyLeaf;
  });
  return getflyleafFront;
};

export const orderBy = (array, sortby, sort = 'asc') => _.orderBy(array, sortby, sort);

export const generateId = (excludeIds = [], start = 10) => {
  const num = !isNaN(excludeIds.slice(-1).pop()) ? parseInt((excludeIds.slice(-1).pop()), 10) + 10 : 10;
  const randomNumber = excludeIds.length === 0 ? start : parseInt(num, 10);
  return randomNumber;
};


export const calculateRatio = (ratio, object, templateWidthRatio, isPortrait = false) => {
  const required = ['height', 'width', 'top', 'left'];
  const validProperties = required.every(element => Object.keys(object).indexOf(element) > -1);

  if (!validProperties) {
    throw new Error('Missing object properties.');
  }

  return {
    height: object.height * ratio,
    originalHeight: object.height * ratio,
    width: isPortrait ? object.width * templateWidthRatio :  object.width * ratio,
    originalWidth: isPortrait ? object.width * templateWidthRatio :  object.width * ratio,
    top: object.top > 0 ? object.top * ratio : object.top,
    originalTop: object.top > 0 ? object.top * ratio : object.top,
    left: object.left > 0 ? object.left * ratio : object.left,
    originalLeft: object.left > 0 ? object.left * ratio : object.left,
  };
};

export function orientation(rowWidth, rowHeight) {
  let imageOrientation;

  const width = parseInt(rowWidth, 10);
  const height = parseInt(rowHeight, 10);

  if (width > height) {
    imageOrientation = 'landscape';
  } else if (width === height) {
    imageOrientation = 'square';
  } else {
    imageOrientation = 'portrait';
  }
  return imageOrientation;
}

export function loadProImages(store, maxSheets) {
  const maxNumberOfPages = maxSheets;
  store.dispatch(autoFill(maxNumberOfPages));
}

export function configExist(key, referer) {
  const domain = config[referer] !== undefined ? referer : Object.keys(config).filter(propertyName => propertyName.indexOf(referer) >= 0);

  if (!config || !config[domain]) {
    const reloadString = 'isReloaded';

    if (window.location.hash) {
      document.cookie = `${reloadString}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      throw new Error('Config is not set');
    }

    if (!window.location.hash) {
      window.location += '#reloaded';
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }


    throw new Error('Config is not set');
  }

  const parameter = config[domain][key];
  if (parameter === undefined) {
    throw new Error(`${key} is missing or not working from config`);
  }

  return parameter;
}

export function addPropertiesToImage(image, url, index) {
  const editorImage = Object.assign({}, image);
  editorImage.imageId = image.id;
  editorImage.imageOrder = index;
  editorImage.thumb = url + image.thumbnailPath + image.fileName;
  editorImage.mediumThumbnail = url + image.mediumThumbnailPath + image.fileName;
  editorImage.url = url + image.path + image.fileName;
  editorImage.originalHeight = image.height;
  editorImage.originalWidth = image.width;
  editorImage.width = image.width;
  editorImage.height = image.height;
  editorImage.orientation = orientation(image.width, image.height);

  return editorImage;
}

export function getEditorImages(galleryData, newImage = false, store) {
  const referer = getDomain();

  const url = configExist('legacyUrl', referer);
  const {
    items: otherImages,
  } = galleryData;
  if (!newImage && otherImages !== undefined) {
    const { type } = store.getState().bookProperties.cover;

    const CoverImage = otherImages.slice(0, 1);
    // Don't add image to cover page
    if (!autofillDisableDropCoverType().includes(type)) {
      CoverImage[0].isCover = true;
    }

    const loadableCover = convertObjectToArray(Object.assign({}, CoverImage));
    const loadableImages = convertObjectToArray(Object.assign({}, otherImages.slice(1)));

    const content = [...loadableCover, ...loadableImages];

    return content.map((image, index) => addPropertiesToImage(image, url, index));
  }
  return galleryData.map((image, index) => addPropertiesToImage(image, url, index));
}

export function loadDefaultImages(galleryData, store, newImage = false) {
  const editorImages = getEditorImages(galleryData, newImage, store);
  store.dispatch(loadImages(editorImages));
}

export function startAutofill(store, lang, maxSheets) {
  store.dispatch(setAutoFill(true));
  autoFillNotice(lang, store);
  loadProImages(store, maxSheets);
}


export function getSelectedCover(response) {
  const selected = response.cover;
  const format = getCoverOrientation(response.dimensions.pageWidth, response.dimensions.pageHeight);
  const context = getContext();
  const coverType = context === 'consumer' ? loadConsumerCoverTemplates : loadProCoverTemplates;
  const coverTemplates = coverType[format][selected.type];
  const selectedCover = coverTemplates.sizes.filter(element => element.label === selected.label);

  return selectedCover[0].margin;
}

export function convertObjectToArray(array) {
  array[Symbol.iterator] = function* () {
    const keys = Object.keys(array);

    for (const element of keys) {
      yield array[element];
    }
  };
  const newArray = [...array];
  return newArray;
}

export function getCoverRatio(editorWidth, placeholderWidth) {
  return editorWidth / placeholderWidth;
}

export function getRatio(editorHeight, originalHeight) {
  return originalHeight / editorHeight;
}

export function GetActivePage(byId) {
  const converterbyId = convertObjectToArray(byId);
  const activePage = converterbyId.find(page => page.isActive === true);

  return activePage || null;
}

export function orderByAllIds(oldArray) {
  if (!Object.prototype.hasOwnProperty.call(oldArray, 'byId') && Object.prototype.hasOwnProperty.call(oldArray, 'allIds')) {
    throw new Error('Missing properties!');
  }

  const orderedArray = [];
  oldArray.allIds.map((Id) => {
    if (oldArray.byId[Id]) {
      orderedArray.push(oldArray.byId[Id]);
    }
    return null;
  });
  return orderedArray;
}

export function GetHoveredplaceholderId(byId) {
  const placeholders = convertObjectToArray(byId);
  const hoveredTexture = placeholders.find(texture => texture.hovered === true);
  return hoveredTexture;
}

export function isImageInChange(isChange, isCoverImage = false, lang) {
  if (isChange) {
    const type = 'error';
    const title = lang.title_notice;
    const message = isCoverImage ? lang.add_image_to_empty_field : lang.add_image_to_empty_field_or_delete;
    swal(title, message, type);
  }
  return isChange;
}


export async function showAlertModal(title, message, type = 'error') {
  await swal(title, message, type);
}

export function autoFillNotice(lang, store) {
  const type = 'warning';
  const title = lang.title_notice;
  const message = lang.check_before_order;
  swal(title, message, type);
}

export function SetActivePage(order, pages, next = true) {
  const prevOrder = order - 1;
  const nextOrder = order + 1;
  const prevPage = Object.values(pages.byId).find(element => element.order === prevOrder);
  const nextPage = Object.values(pages.byId).find(element => element.order === nextOrder);

  return next ? nextPage.id : prevPage.id;
}

export function arrayDiff(array1, array2) {
  const landscapeNumA1 = array1.filter(element => element === 'landscape').length;

  const portraitNumA1 = array1.filter(element => element === 'portrait').length;

  const landscapeNumA2 = array2.filter(element => element === 'landscape').length;

  if (landscapeNumA1 !== landscapeNumA2) {
    return false;
  }

  const portraitNumA2 = array2.filter(element => element === 'portrait').length;

  if (portraitNumA1 !== portraitNumA2) {
    return false;
  }

  return true;
}

export function setLayoutByOrientation(droppedImagesOrientation, droppedImages, orderedLayouts, layoutType = 'isFirstChoice') {
  const firstChoiceOrders = orderBy(orderedLayouts, layoutType, 'asc');

  const sameLayouts = firstChoiceOrders.filter(layout =>
    layout.placeholders.length === Object.keys(droppedImages).length);

  const layoutByImageOrientation = sameLayouts.find(layout => arrayDiff(layout.orientations, droppedImagesOrientation));

  const defaultLayout = orderedLayouts.filter(layout =>
    layout.placeholders.length === Object.keys(droppedImages).length);


  let [firstDefaultLayout] = orderBy(defaultLayout, 'order', 'asc');
  // BabyPlaceholder drop
  if (layoutType === 'isBabyPlaceholder') {
    const babyDefaults = defaultLayout.filter(element => element.isBabyPlaceholder);

    if (layoutByImageOrientation.isBlank) {
      [firstDefaultLayout] = orderBy(babyDefaults, 'order', 'asc').slice(-1);
    } else {
      firstDefaultLayout = layoutByImageOrientation;
    }
    return firstDefaultLayout.id;
  }

  if (!firstDefaultLayout) {
    return false;
  }

  return (layoutByImageOrientation !== undefined) ? layoutByImageOrientation.id : firstDefaultLayout.id;
}

export function reorderArray(pages, layouts) {
  const page = GetActivePage(pages);
  if (page) {
    const droppedImagesLength = Object.keys(page.droppedImages).length;
    const droppedImagesSize = droppedImagesLength === 0 ? 1 : droppedImagesLength;
    const currentLayout = page.placeholders;
    const isChanged = currentLayout.length > droppedImagesSize;
    const isCover = 'isCover';

    return isChanged ?
      layouts.filter(layout =>
        layout.placeholders.length === currentLayout.length && !layout.hasOwnProperty(isCover)) :
      layouts.filter(layout =>
        (!droppedImagesSize && !layout.hasOwnProperty(isCover)) || (layout.placeholders.length === droppedImagesSize && !layout.hasOwnProperty(isCover)));
  }
  return null;
}

export function checkMinimumDPI(context, imageRatio, originalImageWidth, originalPlaceholderWidth, lang, bookSizes) {
  const dataScale = 'data-scale';
  const {
    canvas,
  } = context;

  const zoomLevel = canvas.getAttribute(dataScale);
  const imageSizes = {
    width: Math.round(originalImageWidth / zoomLevel),
  };

  const placeholderSizes = {
    width: Math.round(originalPlaceholderWidth * (bookSizes.width / getOriginalWidth(bookSizes))),
  };

  if (imageRatio > 3) {
    const sizes = {
      bookSize: bookSizes.width,
      imageSize: imageSizes.width,
      placeholderSize: placeholderSizes.width,
    };
    minimumDPICanvasSettings(context, sizes, lang);
    return true;
  }

  return false;
}

export function minimumDPICanvasSettings(context, sizes, lang) {
  const {
    canvas,
  } = context;

  const isClicked = canvas.getAttribute('data-isClicked');
  const canvasText = `${lang.low_resolution}`;
  context.globalAlpha = 0.15;
  if (isClicked === 'false') {
    context.fillStyle = 'red';
    context.globalCompositeOperation = 'source-over';
    context.fillRect(0, 0, canvas.clientWidth, canvas.clientHeight);
    context.globalAlpha = 1;
    context.fillStyle = '#ffffff';
    CanvasTextWrapper(canvas, canvasText, {
      font: '18px Arial, sans-serif',
      textAlign: 'center',
      verticalAlign: 'middle',
      sizeToFill: true,
      paddingX: 10,
      paddingY: 30,
      maxFontSizeToFill: 16,
      fitParent: false,
      renderHDPI: false,
    });
  } else {
    context.fillStyle = 'rgba(255, 255, 255, 0)';
  }
  context.globalAlpha = 1;

  context.globalCompositeOperation = 'destination-over';

  return context;
}

export function getDefaultColors() {
  const colors = ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E', '#7BBCB7', '#FAD4D8', '#FFDFBA', '#FFF3B0', '#C4E6A0', '#A0E6CE', '#B5D8EB', '#D0BFFF', '#E6C1E6', '#F5B9A8', '#F5E6CC', '#BCCEF8'];
  return colors;
}

// Get belive layouts
export function getPages(layouts) {
  const bookProperties = {
    isCover: 'isCover',
    isFrontFlyleaf: 'isFrontFlyleaf',
    isBackFlyleaf: 'isBackFlyleaf',
    isBabyPlaceholder: 'isBabyPlaceholder',
  };

  return layouts.filter(pages => (
    !(bookProperties.isBackFlyleaf in pages) &&
    !(bookProperties.isFrontFlyleaf in pages) &&
    !(bookProperties.isCover in pages) &&
    !(bookProperties.isBabyPlaceholder in pages)
  ));
}

export function getImageObjectById(imagesById, imageId) {
  return convertObjectToArray(imagesById).find(image => image.id === imageId);
}

export function isCoverOrFlyLeaf(page) {
  const {
    isCover,
    isBackFlyLeaf,
    isFrontFlyLeaf,
  } = page;
  const isCoverOrFlyLeafes = ('isCover' in page && isCover) ||
    ('isBackFlyLeaf' in page, isBackFlyLeaf) ||
    ('isFrontFlyLeaf' in page, isFrontFlyLeaf);
  return isCoverOrFlyLeafes;
}

export function isFlyleaf(page) {
  const {
    isBackFlyLeaf,
    isFrontFlyLeaf,
  } = page;
  const isFlyleaf = ('isBackFlyLeaf' in page, isBackFlyLeaf) ||
    ('isFrontFlyLeaf' in page, isFrontFlyLeaf);
  return isFlyleaf;
}

export function getFillSize(placeholderSize, imageSize, bookSizes, rotate = 0) {
  let fillImageSize = {
    width: 0,
    height: 0,
  };

  let hRatio = placeholderSize.width / imageSize.width;
  let vRatio = placeholderSize.height / imageSize.height;
  if (rotate === 90 || rotate === 270) {
    vRatio = placeholderSize.width / imageSize.height;
    hRatio = placeholderSize.height / imageSize.width;
  }

  const ratio = Math.max(hRatio, vRatio);
  const isRotated = rotate === 90 || rotate === 270;
  const fillSizes = {
    width: isRotated ? Math.round(imageSize.height * ratio) : Math.round(imageSize.width * ratio),
    height: isRotated ? Math.round(imageSize.width * ratio) : Math.round(imageSize.height * ratio),
    printWidth: isRotated ? Math.round((imageSize.height * ratio)) : Math.round((imageSize.width * ratio)),
    printHeight: isRotated ? Math.round((imageSize.width * ratio)) : Math.round((imageSize.height * ratio)),
  };

  fillImageSize = {
    width: fillSizes.width,
    height: fillSizes.height,
    printWidth: fillSizes.printWidth,
    printHeight: fillSizes.printHeight,
  };

  return fillImageSize;
}

export function getEditorRatio(target, layout, coverSize = null, bookSizes) {
  let ratio = 1;
  const editorDOM = document.querySelector(target);

  if (editorDOM) {
    if (layout.isCover) {
      const coverRatio = getCoverPrintSizes(coverSize.width, coverSize.height);
      ratio = editorDOM.clientHeight / coverRatio.height;
    } else {
      ratio = editorDOM.offsetHeight / getOriginalHeight(bookSizes);
      if ((getOriginalHeight(bookSizes) * ratio * 2 > editorDOM.offsetWidth) && bookFormat !== 'portrait') {
        ratio = editorDOM.offsetWidth / (getOriginalHeight(bookSizes) * 2);
      }
    }
  }

  return ratio;
}

export function getFitSize(height, width, rotate, layoutObject, bookSizes) {
  const ratio = getEditorRatio('.EditorInner', layoutObject, null, bookSizes);
  const isRotated = rotate === 90 || rotate === 270;
  const canvasHeight = isRotated ? width * ratio : height * ratio;
  const canvasWidth = isRotated ? height * ratio : width * ratio;
  const imageWidth = isRotated ? layoutObject.imageObject.height : layoutObject.imageObject.width;
  const imageHeight = isRotated ? layoutObject.imageObject.width : layoutObject.imageObject.height;

  let ImagePlaceholderRatio = Math.min(canvasWidth / imageHeight, canvasHeight / imageWidth);

  const { originalHeight, originalWidth } = layoutObject;
  const getCanvasOrientation = orientation(originalWidth, originalHeight);
  const getImageOrientation = orientation(layoutObject.imageObject.width, layoutObject.imageObject.height);

  if (getCanvasOrientation === 'portrait' && getImageOrientation === 'landscape') {
    ImagePlaceholderRatio = Math.min(canvasWidth / imageWidth);
  } else if (getCanvasOrientation === 'landscape' && getImageOrientation === 'portrait') {
    ImagePlaceholderRatio = Math.min(canvasHeight / imageHeight);
  }

  return {
    width: (imageWidth * ImagePlaceholderRatio) / ratio,
    height: (imageHeight * ImagePlaceholderRatio) / ratio,
  };
}


export function hideComponent() {
  const autofillParam = getAutoFill();
  const contextParam = getContext();
  if (autofillParam === 'true' && contextParam === 'pro') {
    return true;
  }

  return false;
}

export function getCoverOrientation(width, height) {
  const toIntWidth = parseInt(width, 10);
  const toIntHeight = parseInt(height, 10);
  let coverOrientation = 'portrait';
  if (toIntWidth / 2 === toIntHeight) {
    coverOrientation = 'square';
  } else if (toIntHeight / toIntWidth < 0.5) {
    coverOrientation = 'landscape';
  }

  return coverOrientation;
}


export function generatePreview(dispatch, previewID, maxPages, nextId) {
  dispatch(isPreviewFinished('saving'));
  const bookId = getBookId();
  const referer = getDomain();

  generatePagePreview(previewID, dispatch, referer, bookId, maxPages, nextId);
}

function generatePagePreview(previewID, dispatch, referer, bookId, maxPages, nextId) {
  const target = document.querySelector('.InteractiveLayerContainer');
  screenShooter.html2canvas(target, {
    logging: false,
  }).then((canvas) => {
    const image = canvas.toDataURL('image/jpeg', 1.0);
    const previewUrl = configExist('getStateUrl', referer);
    const url = `${previewUrl}/${bookId}/previews/${previewID}`;
    const data = image;

    fetch(url, {
      method: 'POST',
      body: data,
    }).then(res => res.json())
      .catch(error => console.error('Error:', error))
      .then((resp) => {
        if (resp.status === 'ok') {
          dispatch(setIsActive(nextId));
        }

        if (previewID === (maxPages - 1)) {
          dispatch(isPreviewFinished('finished'));
        }
      });
  })
    .catch(error => console.error('Error:', error));
}

export function hasOwerflowText(texts) {
  return Object.values(texts).some(element => element.isOverflow);
}

export function browserNotSupported() {
  const browser = bowser.getParser(window.navigator.userAgent);
  const {
    name,
    version,
  } = browser.getBrowser();
  const browserNotSupported = {
    name: 'Internet Explorer',
    version: '11.0',
  };

  if (name === browserNotSupported.name && version === browserNotSupported.version) {
    return true;
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/redux/helpers/index.jsx